import React, { Component } from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow, Button, IconButton } from '@material-ui/core';
import { DeleteOutline, Add as AddIcon } from '@material-ui/icons';

import Dropdown from '../native/Dropdown';
import ErrorDialog from './ErrorDialog';
import WholesalerPickerDialog from './WholesalerPickerDialog';
import ProductPickerDialog from './ProductPickerDialog';

var request = require('../../utilities/NetworkRequest');
var cache_util = require('../../utilities/CacheUtil');

export default class VoucherDialog extends Component {

  constructor(props) {
    super(props);
    const parsed_body = JSON.parse(this.props.data);
    if (!parsed_body.product_usage) {
      parsed_body.product_usage = {
        is_expand : false,
        selected : {
          key : null,
          label : 'Pilih Tipe Produk'
        },
        data : [
          { key : 'all', label : 'All' },
          { key : 'produk_tertentu', label : 'Produk Tertentu' }
        ]
      };
    }
    this.state = {
      body_error : {
        is_show : false,
        message : ''
      },
      body : parsed_body,
      show_wholesaler_picker : false,
      show_product_picker : false,
      wholesaler_list : (parsed_body.wholesaler_list || []),
      product_list : (parsed_body.product_list || []),
    }
  }

  openWholesalerPicker() {
    this.setState({ show_wholesaler_picker : true });
  }

  componentDidMount() {
    this.autofillCurrentWholesaler();
    this.fetchVoucherWithProduct();
  }

  autofillCurrentWholesaler() {
    let caches = cache_util.onGetCacheData(cache_util.CACHE_INFO);
    let current_users = caches && caches.result && caches.result.user_information;
    const current_wholesaler_id = current_users.wholesaler_id;

    if (!current_wholesaler_id) {
      console.warn('Current wholesaler ID is not available. Skipping autofill of wholesaler list.');
      return;
    }

    if(this.state.body.wholesaler_id === 'TP9999' && this.state.body.is_update === false) return; // Skip autofill for admin user when creating a new voucher) {

    const existing = this.state.body.wholesaler_list || [];
    if (existing.length > 0) return;

    if (current_wholesaler_id !== 'TP9999') {
      const cache_data = cache_util.onGetCacheData(cache_util.CACHE_INFO);
      const user_info = (cache_data && cache_data.result && cache_data.result.dashboard_view && cache_data.result.dashboard_view.sub_home) || {};
      const auto_entry = {
        wholesaler_id : user_info.wholesaler_id || current_wholesaler_id,
        wholesaler_name : user_info.wholesaler_name || ''
      };
      const t_body = this.state.body;
      t_body.wholesaler_list = [ auto_entry ];
      this.setState({
        wholesaler_list : [ auto_entry ],
        body : t_body
      });
      return;
    }

    request.onRequestData(request.OPTION_API_MAIN, '/list/wholesaler', { view_id : 'list_wholesaler' }, (res_data) => {
      if (res_data.code !== 1) return;
      const list = res_data.result || [];
      const match = list.find(item => item.wholesaler_id === this.state.body.wholesaler_id);
      const auto_entry = {
        wholesaler_id : this.state.body.wholesaler_id,
        wholesaler_name : (match && match.wholesaler_name) ? match.wholesaler_name : ''
      };
      const t_body = this.state.body;
      t_body.wholesaler_list = [ auto_entry ];
      this.setState({
        wholesaler_list : [ auto_entry ],
        body : t_body
      });
    });
  }

  fetchVoucherWithProduct() {
    const t_body = this.state.body;
    if (!t_body.is_update) return;
    if (!t_body.wholesaler_id || !t_body.id) return;

    const body = {
      wholesaler_id : t_body.wholesaler_id,
      voucher_id : t_body.id
    };

    request.onRequestData(request.OPTION_API_MAIN, '/post/voucher_with_product', body, (res_data) => {
      const list = (res_data && res_data.code === 1 && Array.isArray(res_data.result))
        ? res_data.result.map(item => ({
            code : item.identity_value,
            name : item.pcode_name,
            uom_selected : item.identity_uom,
            id : item.id,
            wholesaler_id : item.wholesaler_id,
            voucher_id : item.voucher_id,
            created_at : item.created_at,
            updated_at : item.updated_at
          }))
        : [];
      const new_body = this.state.body;
      new_body.product_list = list;
      new_body.product_usage.selected = list.length > 0 ? { key : 'produk_tertentu', label : 'Produk Tertentu' } : { key : 'all', label : 'All' };
      this.setState({
        product_list : list,
        body : new_body
      });
    });
  }

  openProductPicker() {
    this.setState({ show_product_picker : true });
  }

  closeWholesalerPicker(action, payload) {
    if (action === 'select' && payload) {
      const exists = this.state.wholesaler_list.some(item => item.wholesaler_id === payload.wholesaler_id);
      if (!exists) {
        const new_list = [ ...this.state.wholesaler_list, payload ];
        const t_body = this.state.body;
        t_body.wholesaler_list = new_list;
        this.setState({
          wholesaler_list : new_list,
          body : t_body,
          show_wholesaler_picker : false
        });
      } else {
        this.setState({ show_wholesaler_picker : false });
      }
    } else {
      this.setState({ show_wholesaler_picker : false });
    }
  }

  closeProductPicker(action, payload) {
    if (action === 'select' && payload) {
      const exists = this.state.product_list.some(item => item.code === payload.code);
      if (!exists) {
        const new_list = [ ...this.state.product_list, payload ];
        const t_body = this.state.body;
        t_body.product_list = new_list;
        this.setState({
          product_list : new_list,
          body : t_body,
          show_product_picker : false
        });
      } else {
        this.setState({ show_product_picker : false });
      }
    } else {
      this.setState({ show_product_picker : false });
    }
  }

  removeWholesaler(index) {
    const list = [ ...this.state.wholesaler_list ];
    list.splice(index, 1);
    const t_body = this.state.body;
    t_body.wholesaler_list = list;
    this.setState({ wholesaler_list : list, body : t_body });
  }

  removeProduct(index) {
    const list = [ ...this.state.product_list ];
    list.splice(index, 1);
    const t_body = this.state.body;
    t_body.product_list = list;
    this.setState({ product_list : list, body : t_body });
  }

  onEditTextChanged(event, action) {
    let temp_data = this.state.body;
    temp_data[action] = event.target.value;
    this.setState({ body : temp_data });
  }

  showErrorDialog(body) {
    if (body.is_show) {
      return <ErrorDialog body_error={body} onCloseDialog={() => this.setState({ body_error : { is_show : false, message : '' } })}/>
    } else {
      return null;
    }
  }

  onSaveClicked() {
    try {
      if (this.state.body.description.length === 0) { throw Error('Kolom deskripsi tidak boleh kosong..!!'); }
      if (this.state.body.type_voucher.selected.key === null) { throw Error('Silahkan pilih tipe voucher terlebih dahulu..!!'); }
      if (this.state.body.discount.length === 0) { throw Error('Kolom potongan harga tidak boleh kosong..!!'); }
      if (isNaN(this.state.body.discount)) { throw Error('Kolom potongan harga harus berupa angka..!!'); }
      if (this.state.body.minimum_purchase.length === 0) { throw Error('Kolom minimal pembelian tidak boleh kosong..!!'); }
      if (isNaN(this.state.body.minimum_purchase)) { throw Error('Kolom minimal pembelian harus berupa angka..!!'); }
      if (this.state.body.max_claim.length === 0) { throw Error('Kolom maksimal klaim tidak boleh kosong..!!'); }
      if (isNaN(this.state.body.max_claim)) { throw Error('Kolom maksimal klaim harus berupa angka..!!'); }
      if (!this.state.body.is_update && this.state.body.image === null) { throw Error('Belum ada gambar yang akan anda unggah!'); }
      if(this.state.body.product_usage.selected.key === 'produk_tertentu' && this.state.product_list.length === 0) { throw Error('Belum ada produk yang dipilih..!!'); }
      if(this.state.body.wholesaler_id === 'TP9999' && this.state.body.type_voucher.selected.key === 'inner_delivery' && this.state.wholesaler_list.length === 0) { throw Error('Belum ada grosir yang dipilih..!!'); }

      if (this.state.body.type_voucher.selected.key === 'inner_vloyalty') {
        if (this.state.body.list_ws_loyalty.selected.key === null) { throw Error('Silahkan pilih point loyalty terlebih dahulu..!!'); }

        if (this.state.body.claim_value.length === 0) { throw Error('Kolom potongan loyalty tidak boleh kosong..!!'); }
        if (isNaN(this.state.body.claim_value)) { throw Error('Kolom potongan loyalty harus berupa angka..!!'); }
      }

      this.props.onCloseListener('next', this.state.body);
    } catch (e) {
      this.setState({
        body_error : {
          is_show : true,
          message : e.message
        }
      });
    }
  }

  onSelectedImage(event) {
    let temp_data = this.state.body;
    temp_data.image = event.target.files[0];
    this.setState({ body : temp_data });
  }

  getListWsLoyalty() {
    if (this.state.body.type_voucher.selected.key === 'inner_vloyalty') {
      return (
        <div>
          <div className='normal_margin_bottom_b normal_margin_top_e default_text_normal_gray bold_text'>Jenis Loyalty Grosir</div>
          <Dropdown data={this.state.body.list_ws_loyalty}/>
        </div>
      );
    } else { return null; }
  }

  getMaximumClaim() {
    if (this.state.body.type_voucher.selected.key === 'inner_delivery') {
      return (
        <div>
          <div className='normal_margin_top_e default_text_normal_gray bold_text'>Maksimal Klaim</div>
          <input onChange={ (event) => this.onEditTextChanged(event, 'max_claim') } value={this.state.body.max_claim} style={{width:250}} spellCheck='false' className='normal_margin_top default_text_normal_gray non_transparent_input' type='text' />
        </div>
      );
    } else { return null; }
  }

  getClaimValue() {
    if (this.state.body.type_voucher.selected.key === 'inner_vloyalty') {
      return (
        <div>
          <div className='normal_margin_top_e default_text_normal_gray bold_text'>Jumlah Loyalty Terpotong</div>
          <input onChange={ (event) => this.onEditTextChanged(event, 'claim_value') } value={this.state.body.claim_value} style={{width:250}} spellCheck='false' className='normal_margin_top default_text_normal_gray non_transparent_input' type='text' />
        </div>
      );
    } else { return null; }
  }

  getProductUsageDropdown() {
    if (this.state.body.type_voucher.selected.key === 'inner_delivery') {
      return (
        <div>
          <div className='normal_margin_bottom_b normal_margin_top_e default_text_normal_gray bold_text'>Produk yang digunakan</div>
          <Dropdown data={this.state.body.product_usage} listener_change={this.onChangeProductUsage.bind(this)} />
        </div>
      );
    } else { return null; }
  }

  onChangeProductUsage(data) {
    let t_body = this.state.body;
    t_body.product_usage.selected = {
      key : data.key,
      label : data.label
    };
    if (data.key === 'all') {
      t_body.product_list = [];
      this.setState({ product_list : [], body : t_body });
    } else {
      this.setState({ body : t_body });
    }
  }

  onChangeVoucherType(data) {
    let t_body = this.state.body;
    t_body.list_ws_loyalty.selected = {
      key : null,
      label : 'Pilih Loyalty Grosir'
    }
    if (data.key === 'inner_vloyalty') {
      t_body.max_claim = '999';
    } else {
      t_body.max_claim = '';
    }
    t_body.claim_value = '';
    this.setState({ body : t_body })
  }

  renderWholesalerSection() {
    const { wholesaler_list } = this.state;
    return (
      <div style={{ marginTop: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          <div className='default_text_normal_gray bold_text'>Daftar Grosir</div>
          {this.state.body.wholesaler_id === 'TP9999' && (
            <Button
              size='small'
              variant='outlined'
              color='primary'
              startIcon={<AddIcon />}
              onClick={this.openWholesalerPicker.bind(this)}
            >
              Tambah Grosir
            </Button>
          ) }
        </div>
        <Table size='small' style={{ backgroundColor: '#fff' }}>
          <TableHead>
            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
              <TableCell style={{ width: 50, fontWeight: 'bold' }}>#</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Kode Grosir</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Nama Grosir</TableCell>
              <TableCell style={{ width: 80, fontWeight: 'bold' }}>Aksi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {wholesaler_list.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} style={{ textAlign: 'center', color: '#999', fontStyle: 'italic' }}>
                  Belum ada grosir dipilih
                </TableCell>
              </TableRow>
            ) : wholesaler_list.map((item, idx) => (
              <TableRow key={`ws-${idx}-${item.wholesaler_id}`} hover>
                <TableCell>{idx + 1}</TableCell>
                <TableCell>{item.wholesaler_id}</TableCell>
                <TableCell>{item.wholesaler_name}</TableCell>
                <TableCell>
                  <IconButton size='small' onClick={() => this.removeWholesaler(idx)}>
                    <DeleteOutline fontSize='small' style={{ color: '#d32f2f' }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }

  renderProductSection() {
    const { product_list } = this.state;
    return (
      <div style={{ marginTop: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          <div className='default_text_normal_gray bold_text'>Daftar Produk</div>
          <Button
            size='small'
            variant='outlined'
            color='primary'
            startIcon={<AddIcon />}
            onClick={this.openProductPicker.bind(this)}
          >
            Tambah Produk
          </Button>
        </div>
        <Table size='small' style={{ backgroundColor: '#fff' }}>
          <TableHead>
            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
              <TableCell style={{ width: 50, fontWeight: 'bold' }}>#</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Kode Produk</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Nama Produk</TableCell>
              <TableCell style={{ width: 80, fontWeight: 'bold' }}>Aksi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {product_list.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} style={{ textAlign: 'center', color: '#999', fontStyle: 'italic' }}>
                  Belum ada produk dipilih
                </TableCell>
              </TableRow>
            ) : product_list.map((item, idx) => (
              <TableRow key={`prd-${idx}-${item.code}`} hover>
                <TableCell>{idx + 1}</TableCell>
                <TableCell>{item.code}</TableCell>
                <TableCell>{item.name}</TableCell>
                <TableCell>
                  <IconButton size='small' onClick={() => this.removeProduct(idx)}>
                    <DeleteOutline fontSize='small' style={{ color: '#d32f2f' }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div onClick={(e) => this.props.onCloseListener('close', null)} className='process_dialog_root layer_a'>
          <div onClick={(e) => e.stopPropagation()} className='add_retail_dialog_container' style={{ width: 800, maxWidth: '90vw', maxHeight: '90vh', overflowY: 'auto', padding: 24 }}>
            {this.showErrorDialog(this.state.body_error)}
            <div>
              <div className='default_text_normal_gray bold_text'>Nama Voucher</div>
              <input onChange={ (event) => this.onEditTextChanged(event, 'description') } value={this.state.body.description} style={{width:250}} spellCheck='false' className='normal_margin_top default_text_normal_gray non_transparent_input' type='text' />
            </div>
            <div className='normal_margin_bottom_b normal_margin_top_e default_text_normal_gray bold_text'>Jenis Voucher</div>
            <Dropdown data={this.state.body.type_voucher} listener_change={this.onChangeVoucherType.bind(this)}/>

            { this.getListWsLoyalty() }

            <div>
              <div className='normal_margin_top_e default_text_normal_gray bold_text'>Besar Potongan</div>
              <input onChange={ (event) => this.onEditTextChanged(event, 'discount') } value={this.state.body.discount} style={{width:250}} spellCheck='false' className='normal_margin_top default_text_normal_gray non_transparent_input' type='text' />
            </div>

            <div>
              <div className='normal_margin_top_e default_text_normal_gray bold_text'>Minimal Pembelian</div>
              <input onChange={ (event) => this.onEditTextChanged(event, 'minimum_purchase') } value={this.state.body.minimum_purchase} style={{width:250}} spellCheck='false' className='normal_margin_top default_text_normal_gray non_transparent_input' type='text' />
            </div>
            { this.getMaximumClaim() }
            { this.getClaimValue() }
            <div className='normal_margin_top_e default_text_normal_gray bold_text'>Upload Gambar</div>
            <input className='normal_margin_bottom_b normal_margin_top default_text_normal_gray' accept='image/x-png,image/jpeg' onChange={(event) => this.onSelectedImage(event) } type='file'/>
            { this.getProductUsageDropdown() }
            { this.state.body.type_voucher.selected.key === 'inner_delivery' && this.renderWholesalerSection() }
            { this.state.body.type_voucher.selected.key === 'inner_delivery' && this.state.body.product_usage.selected.key === 'produk_tertentu' && this.renderProductSection() }
            <div className='button_process_wrapper_b'>
              <div onClick={() => this.props.onCloseListener('close', null)} className='default_text_normal_white_b red_background process_button_C'>Batal</div>
              <div style={{width : 20}}/>
              <div onClick={this.onSaveClicked.bind(this)} className='default_text_normal_white_b green_background process_button_C'>Simpan</div>
            </div>
          </div>
        </div>
        { this.state.show_wholesaler_picker && <WholesalerPickerDialog onCloseListener={this.closeWholesalerPicker.bind(this)} /> }
        { this.state.show_product_picker && <ProductPickerDialog onCloseListener={this.closeProductPicker.bind(this)} wholesaler_ids={this.state.wholesaler_list.map(w => w.wholesaler_id)} /> }
      </div>
    );
  }

}
